import { render, staticRenderFns } from "./Columns.vue?vue&type=template&id=3387151d&"
import script from "./Columns.vue?vue&type=script&lang=ts&"
export * from "./Columns.vue?vue&type=script&lang=ts&"
import style0 from "./Columns.vue?vue&type=style&index=0&id=3387151d&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports